import React from 'react';
import PropTypes from 'prop-types';
import MyMigrosSliders from 'components/mymigros-sliders';

/**
 * @param {string} api_endpoint
 * @param {IMyMigrosSlider[]} sliders
 */
export default function CMSMyMigrosSliders({ api_endpoint, sliders, onboarding_link }) {
    return (
        <div className="cms-mymigros-sliders">
            <MyMigrosSliders
                apiEndpoint={ api_endpoint }
                onboardingLink={ onboarding_link }
                sliders={ sliders }
            />
        </div>
    );
}

CMSMyMigrosSliders.propTypes = {
    api_endpoint: PropTypes.string.isRequired,
    onboarding_link: PropTypes.object,
    sliders: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/mymigros-sliders/index.js